import React, {memo, type ComponentType} from 'react'

/** Local copy of @assistant-ui/react-markdown unstable_memoizeMarkdownComponents. */
export function memoizeOmicsMarkdownComponents(
  components: Record<string, ComponentType<Record<string, unknown>> | undefined> = {},
): Record<string, ComponentType<Record<string, unknown>> | undefined> {
  return Object.fromEntries(
    Object.entries(components).map(([key, value]) => {
      if (!value) return [key, value]
      const Component = value
      const WithoutNode: ComponentType<Record<string, unknown>> = (props) => {
        const {node: _node, ...rest} = props as Record<string, unknown> & {node?: unknown}
        return <Component {...rest} />
      }
      return [key, memo(WithoutNode)]
    }),
  )
}
